"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(target, item) {
  var link = target.tagName !== 'A' && item.querySelector('a');

  if (!link) {
    return;
  }

  link.click();
}